export default __webpack_public_path__ + "static/media/hanzo-ult.ae5213fa.mp3";